(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('article-contents')) {
    customElements.define('article-contents', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const content = document.getElementById(this.dataset.contentId);
        if (!content) return;
        const headings = [...content.querySelectorAll('h2')];
        if (headings.length < 2) return;
        this.dataset.initialized = 'true';
        const list = this.querySelector('ul');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = this.dataset.contentId + '-section-' + (index + 1);
            while (document.getElementById(id)) id += '-heading';
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        this.querySelector('details').open = matchMedia('(min-width: 1000px)').matches;
        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
